(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-card"] && !Shopify.designMode) return;
  try {
    if (window.matchMedia('(max-width: 768px)').matches) {
    document.querySelectorAll('.group\\/card').forEach(function (card) {
      card.addEventListener('click', function () {
        card.classList.add('click-active');
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
